import { AssetType } from './types';
import { IconName } from '../components/ui/Icon';

/** One icon per placement type — the same mapping the Homepage planner
 *  uses, shared so a placement looks identical on every surface. */
export const ASSET_TYPE_ICON: Record<AssetType, IconName> = {
  'Hero Banner 100%': 'bannerFull',
  'Hero Banner 50%': 'bannerHalf',
  'Homepage Product Grid': 'dashboard',
  'Homepage Collection Cards': 'cards',
  'Homepage Promotional Banner': 'promoStrip',
  'Homepage Product Carousel': 'carousel',
  'Homepage Browse by Room': 'home',
  'Homepage Brand Logo Carousel': 'logoRow',
  'Pop-ups & Banners': 'popup',
  'Navigation Bar': 'navBar',
  Newsletter: 'mail',
  'Instagram Post': 'instagram',
  'Instagram Story': 'instagram',
  'Instagram Reel': 'instagram',
  'Instagram Giveaway': 'instagram',
  'Facebook Post': 'facebook',
  'Banner on PDP': 'tag',
  'Product Label': 'tag',
  'Collection Page': 'tag',
  'Featured products on collection': 'tag',
  Discount: 'sparkle',
};
